const sortValues = ['datumPrijatiaAktu', 'aktId', 'nameSort'];
const defaultSort = 'datumPrijatiaAktu';

export {
  sortValues, defaultSort,
};
